const products = [
  {
    name: '異性專屬配方',
    category: '膠囊劑型',
    img: 'https://readdy.ai/api/search-image?query=health%20supplement%20capsule%20bottle%20vitamin%20complex%20product%20on%20clean%20white%20background%2C%20professional%20commercial%20product%20photography%2C%20green%20label%2C%20minimalist%20style&width=400&height=400&seq=product-01&orientation=squarish',
  },
  {
    name: '好菌加倍',
    category: '粉末劑型',
    img: 'https://readdy.ai/api/search-image?query=probiotic%20powder%20sachet%20health%20supplement%20packet%20product%20on%20white%20background%2C%20clean%20professional%20product%20photography%2C%20green%20packaging%2C%20minimalist&width=400&height=400&seq=product-02&orientation=squarish',
  },
  {
    name: '順暢輕盈',
    category: '果凍劑型',
    img: 'https://readdy.ai/api/search-image?query=collagen%20drink%20bottle%20health%20beverage%20supplement%20on%20clean%20white%20background%2C%20professional%20commercial%20photography%2C%20elegant%20packaging%2C%20light%20green%20tones&width=400&height=400&seq=product-03&orientation=squarish',
  },
  {
    name: '毛孩專屬配方',
    category: '錠劑劑型',
    img: 'https://readdy.ai/api/search-image?query=herbal%20plant%20extract%20tablet%20supplement%20bottle%20on%20white%20background%2C%20professional%20product%20photography%2C%20natural%20green%20packaging%2C%20clean%20minimal%20style&width=400&height=400&seq=product-04&orientation=squarish',
  },
  {
    name: '日常營養',
    category: '軟膠囊劑型',
    img: 'https://readdy.ai/api/search-image?query=fish%20oil%20omega3%20softgel%20capsule%20supplement%20bottle%20on%20white%20background%2C%20professional%20health%20product%20photography%2C%20clean%20minimal%20packaging%2C%20golden%20soft%20capsules%20visible&width=400&height=400&seq=product-05&orientation=squarish',
  },
];

export default function ProductShowcaseSection() {
  return (
    <section className="py-20 bg-[#f7faf7]">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
            代工產品範例
          </span>
          <h2 className="text-[#1a2e1a] font-bold mb-4">
            多元熱銷配方，滿足市場需求
          </h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
            康永生技提供多樣產品配方，依客戶需求量身打造，搭配其適合的劑型，協助品牌產品擁有市場獨特性
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 sm:gap-4">
          {products.map((p) => (
            <div
              key={p.name}
              className="w-[calc(50%-0.375rem)] sm:w-[calc(33.333%-0.667rem)] lg:w-[calc(20%-0.8rem)] bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-green-200 hover:-translate-y-1 transition-all duration-300 group cursor-default"
            >
              <div className="w-full h-[200px] sm:h-[220px] overflow-hidden">
                <img
                  src={p.img}
                  alt={p.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-3 text-center">
                <span className="text-[#4CAF50] text-[0.75rem] font-medium">{p.category}</span>
                <p className="text-[#1a2e1a] font-semibold text-[0.875rem] mt-1">{p.name}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}